import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import { Button, Input, Space, Row, Col, Drawer } from 'antd';
import { isMobile } from 'react-device-detect';
import { _newLine } from '../../../utils/helpers';
import { UserOutlined } from '@ant-design/icons';
import { getCustomerServices } from '@/redux/actions/CustomerServicesActions'
import BaseSelect from '@/components/Elements/BaseSelect';
import { createTreatmentNote, updateTreatmentNote } from '@/redux/actions/treatmentNoteActions';

class NoteForm extends Component {
    constructor() {
        super();
        this.state = {
            isLoading: false,
            customerServices: []
        };
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.currentItem != this.props.currentItem) {
            if (nextProps?.currentItem?.id) {
                this.props.getCustomerServices(nextProps?.currentItem?.id).then(res => {
                    //console.log(res);
                    this.setState({ customerServices: res });
                });
            }
        }
    }

    async submit(e) {
        e.preventDefault();
        this.props.form.validateFields(async (err, values) => {
            if (!err) {
                this.setState({ isLoading: true });
                try {
                    values.customer_id = this.props.currentItem?.id
                    console.log(values)
                    if (this.props.currentNote) {
                        await this.props.updateTreatmentNote(this.props.currentNote.id, values);
                        this.onClose();
                    } else {
                        await this.props.createTreatmentNote(values);
                        this.onClose();
                    }
                } catch (error) {
                    this.setState({ isLoading: false });
                }
            }
        });
    }

    onClose() {
        this.props.form.resetFields();
        this.props.onCancel();
        this.setState({
            isLoading: false
        });
    }

    render() {
        var { isLoading, customerServices } = this.state;
        var { visible, currentItem, currentNote } = this.props;
        const { getFieldDecorator } = this.props.form;

        //console.log('currentNote', currentNote);

        return (
            <Drawer
                visible={visible}
                title={`${currentNote ? "Sửa ghi chú" : "Tạo ghi chú"}`}
                onClose={() => this.onClose()}
                maskClosable={false}
                width={isMobile ? '100%' : '50%'}
                footer={
                    <div style={{ textAlign: 'right', }}>
                        <Space>
                            <Button key="back" onClick={() => this.onClose()}>
                                Huỷ
                            </Button>
                            <Button
                                loading={isLoading}
                                key="submit"
                                type="primary"
                                onClick={(e) => this.submit(e)}
                            >
                                Lưu
                            </Button>
                        </Space>
                    </div>
                }
            >
                {visible ?
                    <Form layout='vertical'>
                        <Row gutter={16}>
                            <Col xs={24} md={24} className='mb-3'>
                                <h6><UserOutlined />{' '}
                                    <span className='color-primary'>
                                        {currentItem?.full_name + ' - ' + currentItem?.code}
                                    </span>
                                </h6>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} md={12}>
                                <Form.Item label='Dịch vụ'>
                                    {getFieldDecorator("service_id", {
                                        rules: [
                                            {
                                                required: false,
                                                message: "Vui lòng chọn!",
                                            },
                                        ],
                                        initialValue: currentNote ? currentNote.service_id : null
                                    })(
                                        <BaseSelect
                                            options={customerServices ?? []}
                                            optionValue="service_id"
                                            optionLabel="service_name"
                                            placeholder="Chọn dịch vụ"
                                            defaultText="Chọn dịch vụ"
                                            showSearch={true}
                                            style={{ width: '100%' }}
                                        />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col xs={24} md={24}>
                                <Form.Item label="Nội dung">
                                    {getFieldDecorator('content', {
                                        rules: [
                                            {
                                                required: true,
                                                message: "Vui lòng điền!",
                                            },
                                        ],
                                        initialValue: currentNote ? _newLine(currentNote.content) : ""
                                    })(
                                        <Input.TextArea rows={8} />
                                    )}
                                </Form.Item>
                            </Col>
                        </Row>
                    </Form>
                    : null}
            </Drawer>
        )
    }
}

function mapStateToProps(state) {
    return {

    }
}

function mapDispatchToProps(dispatch) {
    return {
        getCustomerServices: (customer_id) => dispatch(getCustomerServices(customer_id)),
        createTreatmentNote: (data) => dispatch(createTreatmentNote(data)),
        updateTreatmentNote: (id, data) => dispatch(updateTreatmentNote(id, data)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(Form.create({ name: 'NoteForm' })(NoteForm));
